import React, { Component } from 'react'
import ReactDOMServer from 'react-dom/server'
import Api from '@app/api'
import URI from 'urijs'

const MAPPINGS = {
  BR: ['DRAGONLEARN.COM.BR', window.PLATFORM_URL || 'https://dragonlearn.com.br'],
  CN: ['ZHIXUELONG.COM',     window.PLATFORM_URL || 'http://zhixuelong.com'],
  IN: ['DINOLAB.COM',        window.PLATFORM_URL || 'https://dinolab.com'],
  RU: ['UCHi.RU',            window.PLATFORM_URL || 'https://dinolab.com'],
  ZA: ['DRAGONLEARN.CO.ZA',  window.PLATFORM_URL || 'https://dragonlearn.co.za'],
  ID: ['DRAGONLEARN.ORG',    window.PLATFORM_URL || 'https://dragonlearn.org'],
  VN: ['DRAGONLEARN.VN',     window.PLATFORM_URL || 'https://dragonlearn.vn']
}

const DEFAULT_SUBJECT = window.DEFAULT_SUBJECT || 1

const ssoPath = ({ params }) => {
  var query = ''

  if (params) {
    const uri = new URI('/')
    query = `?${uri.search(params).query()}`
  }

  return Api.platform.routes.resourceURL(query)
}

export { ssoPath }

const defaultSubjectPath = () => {
  let href
  [_, href] = MAPPINGS[window.COUNTRY]

  return `${href}/program/${DEFAULT_SUBJECT}`
}

export { defaultSubjectPath }

const platformPath = (subroute = '') => {
  let href
  [_, href] = MAPPINGS[window.COUNTRY]

  return `${href}/${subroute}`
}

export { platformPath }

class PlatformLink extends Component {
  render() {
    let label, href
    [label, href] = MAPPINGS[window.COUNTRY]

    const { theme, sso, text, onlyName, params, ...props } = this.props
    const caption = text || label
    const innerHTML = theme === 'lowercase' ? caption.toLowerCase() : caption

    if (
      window.COUNTRY === 'ZA' || window.COUNTRY === 'CN' ||
      window.COUNTRY === 'ID' || window.COUNTRY === 'VN' || onlyName
    ) { return innerHTML }

    return (
      <a href={sso ? ssoPath({ params: params }) : href}
         target={sso ? '_blank' : '_self'} {...props}>

        {innerHTML}
      </a>
    )
  }
}

PlatformLink.defaultProps = {
  theme: 'uppercase',
  sso: false,
  onlyName: false
}

const SSOPlatformLink = ({ linkProps, ...props }) => {
  if (
    window.COUNTRY === 'CN' || window.COUNTRY === 'IN' ||
    window.COUNTRY === 'ZA' || window.COUNTRY === 'ID' ||
    window.COUNTRY === 'VN'
  ) { return null }

  const platform = () => {
    return {
      __html: I18n.t('landing.platform_html', {
        platform: platformLinkToString({ ...linkProps, sso: true })
      })
    }
  }

  return ( <p {...props} dangerouslySetInnerHTML={ platform() } /> )
}

export { SSOPlatformLink }

export function platformLinkToString(props = {}) {
  return ReactDOMServer.renderToString(
    <PlatformLink {...props} />
  )
}

export default PlatformLink

class PreparatoryPlatformLink extends Component {
  render() {
    let label, href
    [label, href] = MAPPINGS[window.COUNTRY]

    const { theme, sso, text, linkProps, ...props } = this.props
    const caption = text || label

    const platformTitle = () => {
      return {
        __html: I18n.t('awards.not_participated_heading_dinolab', {
          platform: theme === 'lowercase' ? caption.toLowerCase() : caption
        })
      }
    }

    const platformDescs = [
      () => {
        return { __html: I18n.t('landing.platform_detail_html_desc_0') }
      },
      () => {
        return { __html: I18n.t('landing.platform_detail_html_desc_1') }
      }
    ];

    return (
      <a href={sso ? ssoPath({ params: linkProps }) : href}
         target={sso ? '_blank' : '_self'} {...props}>
        <p className='platform-detail-title' dangerouslySetInnerHTML={ platformTitle() } />
        <p className='platform-detail-desc-0' dangerouslySetInnerHTML={ platformDescs[0]() } />
        <p className='platform-detail-desc-1' dangerouslySetInnerHTML={ platformDescs[1]() } />
      </a>
    )
  }
}

PreparatoryPlatformLink.defaultProps = {
  theme: 'uppercase',
  sso: false,
  linkProps: {}
}

const SSOPreparatoryPlatformLink = ({ ...props }) => {
  props.sso = true;

  return <PreparatoryPlatformLink {...props} />
}

export { SSOPreparatoryPlatformLink, PreparatoryPlatformLink }
